import type { GameVersion } from '@/mocks/updates';

interface VersionListProps {
  versions: GameVersion[];
  activeVersion: string;
  onSelect: (version: string) => void;
}

export default function VersionList({ versions, activeVersion, onSelect }: VersionListProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50">
      <div className="border-b border-background-200 px-5 py-4">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-history-line text-primary-600"></i>
          版本历史
        </h2>
      </div>
      <ul className="p-3">
        {versions.map((version) => {
          const active = version.version === activeVersion;
          return (
            <li key={version.version}>
              <button
                type="button"
                onClick={() => onSelect(version.version)}
                className={`flex w-full items-center gap-3 rounded-md px-3 py-3 text-left transition-colors ${
                  active ? 'bg-primary-50' : 'hover:bg-background-100'
                }`}
              >
                <span
                  className={`flex h-10 w-12 flex-shrink-0 flex-col items-center justify-center rounded-md text-sm font-bold ${
                    active ? 'bg-primary-500 text-background-50 dark:text-foreground-950' : 'bg-background-200 text-foreground-700'
                  }`}
                >
                  {version.version}
                </span>
                <span className="min-w-0 flex-1">
                  <span
                    className={`block truncate text-sm font-semibold ${
                      active ? 'text-primary-700' : 'text-foreground-900'
                    }`}
                  >
                    {version.name}
                  </span>
                  <span className="text-xs text-foreground-500">{version.date}</span>
                </span>
                <i
                  className={`ri-arrow-right-s-line ${
                    active ? 'text-primary-500' : 'text-foreground-300'
                  }`}
                ></i>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}